import { useEffect } from 'react';
import LeftSidePopupLayout from './modal-layout';
import XCloseIcon from '../icons/x-close';
import Style from './style.module.css'
import { useApiCall } from '../custom-hooks/api-call';
import { useFormik } from 'formik';
import * as yup from "yup";

const VanModal = ({ onSubmit = () => { }, onClose = () => { }, onError = () => { }, vanData, vendors = [], shifts = [] }) => {
  const apiCall = useApiCall();

  useEffect(() => {
    if (vanData?.id) {
      formik.setFieldValue("vendor", vanData?.v_id || "")
      formik.setFieldValue("driverName", vanData?.van_entitlement || "")
      formik.setFieldValue("contactNumber", vanData?.contact_number || "")
      formik.setFieldValue("license", vanData?.driver_license || "")
      formik.setFieldValue("licenseExp", vanData?.driver_license_expiry || "")
      formik.setFieldValue("cnic", vanData?.driver_cnic_url || "")
      formik.setFieldValue("cnicExp", vanData?.driver_cnic_expiry || "")
      formik.setFieldValue("shift", vanData?.shift || "")
      formik.setFieldValue("route", vanData?.route || "")
      formik.setFieldValue("registration", vanData?.registration_number || "")
      formik.setFieldValue("rent", vanData?.rent || "")
      formik.setFieldValue("is_active", vanData?.status == "Active" ? "yes" : "no")
      formik.setFieldValue("is_conditioner", vanData?.air_cond_type)
    }
  }, [])
  const validationSchema = yup.object({
    vendor: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    driverName: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    contactNumber: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    shift: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    route: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    registration: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    rent: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    is_conditioner: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    is_active: yup
      .string('This Field is Required')
      .required('This Field is Required'),
  });

  const formik = useFormik({
    initialValues: {
      vendor: '',
      driverName: '',
      contactNumber: '',
      license: '',
      licenseExp: '',
      cnic: '',
      cnicExp: '',
      shift: '',
      route: '',
      registration: '',
      rent: '',
      is_conditioner: '',
      is_active: ''
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {

      console.log("values", values)

      let extraData = {};

      if (vanData?.id) {
        extraData = {
          "fleet_van_id": vanData?.id
        }
      }

      let data = {
        ...extraData,
        "registration_number": values?.registration,           
        "van_entitlement": values?.driverName,  
        "v_id": values?.vendor,      
        "rent": values?.rent,
        "shift": values?.shift,
        "route": values?.route,                 
        "contact_number": values?.contactNumber,            
        "air_cond_type": values?.is_conditioner,
        "driver_license": values?.license,
        "driver_license_expiry": values?.licenseExp,
        "driver_cnic_url": values?.cnic,
        "driver_cnic_expiry": values?.cnicExp,
        "status": values?.is_active == "yes" ? "1" : "0",
      }

      try {
        let apiRes = await apiCall({ method: "post", url: "add-update-fleet-van", data: data })
        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error)
        onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
      }

    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout popupStatus={true} className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}>
        <div className={`${Style["modal_header"]} ${Style.addMeModal_head}`}>
          <h4>{(vanData?.id || vanData?.vid) ? "Update" : "Add"} Van</h4>
          <div onClick={onClose} className={`${Style["close_btn"]} cursor-pointer`}><XCloseIcon /></div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>
                <div className={Style["dcmb__cardBody_formArea_feild"]}>
                  <label htmlFor="">Vendor</label>
                  <select name='vendor' value={formik.values.vendor} onChange={formik.handleChange}>
                    <option value="">-- Select Vendor --</option>
                    {vendors?.map((eachVendor, i) => (
                      <option value={eachVendor?.id} key={i}>{eachVendor?.name}</option>
                    ))}
                  </select>
                  {/* { } */}
                  {
                    (formik.touched.vendor && Boolean(formik.errors.vendor)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.vendor && formik.errors.vendor}</span>
                      :
                      null
                  }
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Driver Name</label>
                    <input
                      type="text"
                      name='driverName'
                      min={1}
                      value={formik.values.driverName}
                      onChange={formik.handleChange}
                      placeholder='Driver Name'
                    />
                    {
                      (formik.touched.driverName && Boolean(formik.errors.driverName)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.driverName && formik.errors.driverName}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Contact Number</label>
                    <input
                      type="text"
                      name='contactNumber'
                      min={1}
                      value={formik.values.contactNumber}
                      onChange={formik.handleChange}
                      placeholder='Contact Number'
                    />
                    {
                      (formik.touched.contactNumber && Boolean(formik.errors.contactNumber)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.contactNumber && formik.errors.contactNumber}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">License</label>
                    <input
                      type="text"
                      name='license'
                      min={1}
                      value={formik.values.license}
                      onChange={formik.handleChange}
                      placeholder='License Number'
                    />
                    {
                      (formik.touched.license && Boolean(formik.errors.license)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.license && formik.errors.license}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">License Expiry</label>
                    <input
                      type="date"
                      name='licenseExp'
                      min={1}
                      value={formik.values.licenseExp}
                      onChange={formik.handleChange}
                      placeholder='Expiry Date'
                    />
                    {
                      (formik.touched.licenseExp && Boolean(formik.errors.licenseExp)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.licenseExp && formik.errors.licenseExp}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">CNIC</label>
                    <input
                      type="text"
                      name='cnic'
                      min={1}
                      value={formik.values.cnic}
                      onChange={formik.handleChange}
                      placeholder='CNIC Number'
                    />
                    {
                      (formik.touched.cnic && Boolean(formik.errors.cnic)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.cnic && formik.errors.cnic}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">CNIC Expiry</label>
                    <input
                      type="date"
                      name='cnicExp'
                      min={1}
                      value={formik.values.cnicExp}
                      onChange={formik.handleChange}
                      placeholder='Expiry Date'
                    />
                    {
                      (formik.touched.cnicExp && Boolean(formik.errors.cnicExp)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.cnicExp && formik.errors.cnicExp}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={Style["dcmb__cardBody_formArea_feild"]}>
                  <label htmlFor="">Shift</label>
                  <select name='shift' value={formik.values.shift} onChange={formik.handleChange}>
                    <option value="">-- Select Shift --</option>
                    {shifts?.map((eachShift, i) => (
                      <option value={eachShift} key={i}>{eachShift}</option>
                    ))}
                  </select>
                  {/* { } */}
                  {
                    (formik.touched.shift && Boolean(formik.errors.shift)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.shift && formik.errors.shift}</span>
                      :
                      null
                  }
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Route</label>
                    <input
                      type="text"
                      name='route'
                      min={1}
                      value={formik.values.route}
                      onChange={formik.handleChange}
                      placeholder='Route'
                    />
                    {
                      (formik.touched.route && Boolean(formik.errors.route)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.route && formik.errors.route}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Registration</label>
                    <input
                      type="text"
                      name='registration'
                      min={1}
                      value={formik.values.registration}
                      onChange={formik.handleChange}
                      placeholder='Registration Number'
                    />
                    {
                      (formik.touched.registration && Boolean(formik.errors.registration)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.registration && formik.errors.registration}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Air Conditioner</label>
                    <div className="flex items-center gap-6">
                      <div className="flex items-center gap-1">
                        <input
                          className='!h-5'
                          type="radio"
                          name='is_conditioner'
                          checked={formik.values?.is_conditioner == "ac"}
                          id='activeAuto'
                          value={"ac"}
                          onChange={formik.handleChange}
                        />
                        <label htmlFor="activeAuto" className='!h-5'>AC</label>
                      </div>

                      <div className="flex items-center gap-1">
                        <input
                          className='!h-5'
                          type="radio"
                          name='is_conditioner'
                          checked={formik.values?.is_conditioner == "non_ac"}
                          id='activeManual'
                          value={"non_ac"}
                          onChange={formik.handleChange}
                        />
                        <label htmlFor="activeManual" className='!h-5 !whitespace-nowrap'>Non Ac</label>
                      </div>
                    </div>
                    {
                      (formik.touched.is_conditioner && Boolean(formik.errors.is_conditioner)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.is_conditioner && formik.errors.is_conditioner}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Rent</label>
                    <input
                      type="text"
                      name='rent'
                      min={1}
                      value={formik.values.rent}
                      onChange={formik.handleChange}
                      placeholder='Rent'
                    />
                    {
                      (formik.touched.rent && Boolean(formik.errors.rent)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.rent && formik.errors.rent}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Active</label>
                    {/* <input type="date" placeholder='Type Here' /> */}
                    <div className="flex items-center gap-6">
                      <div className="flex items-center gap-1">
                        <input
                          className='!h-5'
                          type="radio"
                          name='is_active'
                          checked={formik.values?.is_active == "yes"}
                          id='activeYes'
                          value={"yes"}
                          onChange={formik.handleChange}
                        // placeholder='Type is_active In Number'
                        />
                        <label htmlFor="activeYes" className='!h-5'>Yes</label>
                      </div>

                      <div className="flex items-center gap-1">
                        <input
                          className='!h-5'
                          type="radio"
                          name='is_active'
                          id='activeNo'
                          value={"no"}
                          checked={formik.values?.is_active == "no"}
                          onChange={formik.handleChange}
                        />
                        <label htmlFor="activeNo" className='!h-5'>No</label>
                      </div>
                    </div>
                    {
                      (formik.touched.is_active && Boolean(formik.errors.is_active)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.is_active && formik.errors.is_active}</span>
                        :
                        null
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button type='reset' className={`${Style.dcmb__cancel}`} onClick={onClose}>Discard</button>
          <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
        </div>
      </LeftSidePopupLayout>
    </form>
  )
}

export default VanModal